import { Injectable, inject } from '@angular/core';
import { GanttShiftPixelLengthService } from './gantt-shift-pixel-length.service';
import {
  calculateStartingPixel,
  GanttActivityPixelCalculationInput,
} from './calculate-left-right-pixel.fn';

@Injectable({
  providedIn: 'root',
})
export class GanttScrollLeftPixelService {
  private ganttShiftPixelLengthService = inject(GanttShiftPixelLengthService);

  calculate({
    startTime,
    endTime,
    frameLength,
    dayCount,
    timeframe,
    windowWidth,
    resourcesColumnWidthPx,
  }: GanttActivityPixelCalculationInput & {
    windowWidth: number;
    resourcesColumnWidthPx: number;
  }) {
    const shiftLength = this.ganttShiftPixelLengthService.calculate({
      startTime,
      endTime,
      frameLength,
      dayCount,
      timeframe,
    });

    const shiftLeftPx = calculateStartingPixel({
      startTime,
      frameLength,
      dayCount,
      timeframe,
    });

    const shiftMidpointPx = shiftLeftPx + shiftLength / 2;

    return shiftMidpointPx - windowWidth / 2 + resourcesColumnWidthPx;
  }
}
